// extracted by mini-css-extract-plugin
module.exports = {"root":"table-header_root__atYYi"};